import React from 'react'
import SimpleLayout from '../layouts/SimpleLayout'


const MentionsLegalesPage = () => (
  <SimpleLayout title='Mentions'>
    <main className='container' role='main'>
      <h1>Mentions Légales</h1>
        <p className="text-justify">
            Toute information concernant mes travaux se trouvant sur le réseau Internet, en dehors de mon site, qui aura été transmise sans mon autorisation ne saurait donc engager ma responsabilité.
        </p>
        <p className="text-justify">
            Conformément à la loi du 6 janvier 1978, vous disposez d'un droit d'accès et de rectification des données personnelles vous concernant en vous adressant par courrier ou courrier électronique présent sur le site.
        </p>
        <p className="text-justify">
            Je ne suis pas responsable des liens externes. Seuls les opérateurs des sites externes sont responsables de leur propre site.
        </p>
      </main>
  </SimpleLayout>
)

export default MentionsLegalesPage
